import React from "react";
import Select, { components } from "react-select";
import IconWrapper from "./IconWrapper";

export default function IconPicker({ options,value,onSelectionChanged }) {
  const CustomSingleValue = ({ children, data, ...props }) => {
    return (
      <components.SingleValue {...props}>
        <IconWrapper icon={data.icon} />
        {/* {children} */}
      </components.SingleValue>
    );
  };

  const CustomOption = (props) => {
    // const { data, children, innerRef, innerProps } = props;
    const { data, ...restProps } = props;
    return  (
      <components.Option {...restProps}>
        <IconWrapper icon={data.icon} />
        {/* {children} */}
      </components.Option>)
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      textAlign:'center'
    }),
    control: (provided) => ({
      ...provided,
      width: 90,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
  
      return { ...provided, opacity, transition };
    }
  }

  return (
    <Select
      styles={customStyles}
      value={value}
      components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
      options={options}
      onChange={onSelectionChanged}
    />
  );
}